// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAl0f_tZ2Lt9QkApvD6UiHT4xNXj7cMTKY",
  authDomain: "protipmatch-4c858.firebaseapp.com",
  projectId: "protipmatch-4c858",
  storageBucket: "protipmatch-4c858.firebasestorage.app",
  messagingSenderId: "895946193597",
  appId: "1:895946193597:web:4344b33e85337e759a15d4",
  measurementId: "G-69H5VKW7MK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);